
export class OccupancyLog {
  public id: string;
  public datetime?: Date;
  public deviceId: string;
  public sensorId: string;
  public status: string;
}
